import React from 'react';

export const Svg = ({ children, ...props }: any) => {
  return <svg {...props}>{children}</svg>;
};

export const Path = (props: any) => {
  return <path {...props} />;
};

export const Circle = (props: any) => {
  return <circle {...props} />;
};

export const Rect = (props: any) => {
  return <rect {...props} />;
};

export const Polygon = (props: any) => {
  return <polygon {...props} />;
};

export const Polyline = (props: any) => {
  return <polyline {...props} />;
};

export const Line = (props: any) => {
  return <line {...props} />;
};

export const G = ({ children, ...props }: any) => {
  return <g {...props}>{children}</g>;
};

export default Svg;
